// Stat summary card
const SummaryCard = ({ icon: Icon, label, value, color }) => (
  <div
    className="flex items-center bg-white rounded-[14px] border border-slate-100"
    style={{
      padding: '18px 22px',
      gap: '14px',
      boxShadow: '0 1px 8px rgba(0,0,0,0.06)',
      flex: '1 1 160px',
      minWidth: '160px',
    }}
  >
    <div
      className="flex items-center justify-center shrink-0 w-11 h-11 rounded-xl"
      style={{ background: color }}
    >
      <Icon size={20} color="#fff" strokeWidth={2} />
    </div>
    <div>
      <div className="text-[22px] font-bold text-slate-900 leading-[1.2]">
        {value}
      </div>
      <div className="text-xs text-slate-400 mt-0.5">{label}</div>
    </div>
  </div>
);

export default SummaryCard;
